import { createFileRoute } from "@tanstack/react-router";
import { css } from "../../../../styled-system/css";
import { VStack } from "../../../../styled-system/jsx";
import { PageContainer } from "../../../components/core/basic/PageContainer";
import { VideoGenerationRequestsTable } from "../../../components/custom/video-generation/VideoGenerationRequestsTable";
import { useGetAiVideoGenRequests } from "../../../modules/perf_reports/api/assets/useGetAiVideoGenTaskResults";
import { VideoGenerationDialogue } from "../../../components/custom/video-generation/VideoGenerationDialogue";
import Loading from "../../../components/core/blocks/Loading";
import { DatesProvider } from "../../../dates/DatesContext";
import { useTranslation } from "react-i18next";

const VideoGenerationPage = () => {
  const { t } = useTranslation(["advertising"]);
  const requestsFilters = {
    state: ["PENDING", "IN_PROGRESS", "SUCCESS", "FAILED"],
  };
  const videoGenerationRequestsQuery = useGetAiVideoGenRequests(requestsFilters);
  const videoGenerationRequests = videoGenerationRequestsQuery.data?.results ?? [];

  return (
    <DatesProvider>
      <PageContainer>
        <VStack
          gap="medium"
          alignItems="stretch"
          alignSelf="center"
          width="100%"
          maxWidth="1400px"
          paddingY="large"
          fontSize="large"
          paddingX={{ base: "medium", md: "xxlarge" }}
        >
          <h1 className={css({ textAlign: "center", fontSize: "xxlarge", fontWeight: "bold" })}>
            {t(($) => $.advertising["AI Video Generation"])}
          </h1>
          <VideoGenerationDialogue />
          {videoGenerationRequestsQuery.isLoading ?
            <Loading />
          : <VideoGenerationRequestsTable requestsData={videoGenerationRequests} />}
        </VStack>
      </PageContainer>
    </DatesProvider>
  );
};

export const Route = createFileRoute("/_authenticated/user/videogen")({
  component: VideoGenerationPage,
  staticData: { application: "Advertising" },
});
